// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getFormattedLanguage } = require('../utilities/RALanguageHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { SUITABILITY_TEST_ALL_PRODUCTS } = require('../raConstants/index');

const portfolioDistributionSuccess = data => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_SUCCESS,
    payload: {
        portfolio: data.products,
    },
});

const portfolioDistributionFailure = error => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_FAILURE,
    payload: {
        error,
    },
});

const requestPortfolioDistributionInProgress = () => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_GET_DISTRIBUTION_REQUEST,
});

const resetComparative = (portfolioId, originalPortfolio) => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_RESET_COMPARATIVE,
    payload: {
        portfolioId,
        originalPortfolio,
    },
});

const resetPortfolio = () => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_RESET_PORTFOLIO,
});

const cancelModifyPlanModal = () => ({
    type: actionTypes.RA_PORTFOLIO_DISTRIBUTION_CANCEL_MODIFY_PLAN_MODAL,
});

const requestPortfolioDistribution = portfolioId => (dispatch, getState) => {
    dispatch(requestPortfolioDistributionInProgress());
    const language = getFormattedLanguage();
    const requestData = {
        header: {
            'Accept-Language': language,
        },
        query: {
            weightDecimals: 4,
        },
    };
    const params = {
        typeOfProduct: SUITABILITY_TEST_ALL_PRODUCTS, // Any value different than Profile Ids [1,2,3,4,5] to bring all products in this case 0
    };
    const immGlobalPosition = getState().raGlobalPosition;

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raPortfolioDistribution', params),
        requestData,
    )
        .then(response => {
            dispatch(portfolioDistributionSuccess(response));
            if (portfolioId) {
                const investProfile = immGlobalPosition.getIn([
                    'portfolios',
                    portfolioId,
                    'product',
                    'typeOfProduct',
                ]);
                const originalPortfolio = immGlobalPosition.getIn([
                    'portfolios',
                    portfolioId,
                ]);
                dispatch(resetComparative(investProfile, originalPortfolio));
            }
        })
        .catch(error => {
            if (error.error) {
                dispatch(portfolioDistributionFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

module.exports = {
    requestPortfolioDistribution,
    resetPortfolio,
    cancelModifyPlanModal,
};
